import { z } from 'zod';
import {
  moneySummarySchema,
  paymentMethodSchema,
  transactionSchema,
  type AddPaymentMethodInput,
  type MoneySummary,
  type Page,
  type PaymentMethod,
  type Transaction,
  type TransactionListQuery,
} from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';
import { fetchPage } from '@/lib/api-page';

const methodListSchema = z.object({ items: z.array(paymentMethodSchema) });

export async function fetchPaymentMethods(): Promise<PaymentMethod[]> {
  return methodListSchema.parse(await apiFetch<unknown>('/payments/methods')).items;
}

export async function addPaymentMethod(input: AddPaymentMethodInput): Promise<PaymentMethod> {
  return paymentMethodSchema.parse(await post<unknown>('/payments/methods', input));
}

export async function setDefaultPaymentMethod(methodId: string): Promise<PaymentMethod> {
  return paymentMethodSchema.parse(
    await post<unknown>(`/payments/methods/${methodId}/default`, {}),
  );
}

export async function removePaymentMethod(methodId: string): Promise<{ removed: boolean }> {
  return apiFetch<{ removed: boolean }>(`/payments/methods/${methodId}`, { method: 'DELETE' });
}

export function fetchTransactions(
  query: Partial<TransactionListQuery> = {},
): Promise<Page<Transaction>> {
  return fetchPage('/payments/transactions', transactionSchema, query);
}

export async function fetchMoneySummary(): Promise<MoneySummary> {
  return moneySummarySchema.parse(await apiFetch<unknown>('/payments/summary'));
}
